import React from "react";
import Conditions from "./Resources/Conditions";
import "../styles/Resources.css";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Material from "./Material";
import Support from "./Resources/Support";

const Resources = () => {
  return (
    <div className="resources">
      <title>Resources</title>

      <HelmetProvider>
        <Helmet>
          {/* Basic Meta */}
          <title>Resources</title>
          <meta
            name="description"
            content="Explore emergency room protocols, outpatient care, ICU care, and resources like Air Stacking and Glossopharyngeal Breathing (GPB) for patients with neuromuscular diseases."
          />
          <meta
            name="keywords"
            content="Emergency Room protocols, outpatient care, ICU care, Air Stacking, Glossopharyngeal Breathing, neuromuscular diseases, Dr. Bach"
          />
          <meta name="author" content="DoctorBach.com" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />

          {/* Open Graph Meta (for Facebook, LinkedIn, etc.) */}
          <meta property="og:title" content="Resources | DoctorBach" />
          <meta
            property="og:description"
            content="Learn about ER protocols, outpatient and ICU care protocols, as well as advanced respiratory techniques like Air Stacking and Glossopharyngeal Breathing (GPB)."
          />
          <meta
            property="og:image"
            content="https://doctorbach.com/favicon.png"
          />
          <meta property="og:url" content="https://doctorbach.com/resources" />
          <meta property="og:type" content="website" />
        </Helmet>
      </HelmetProvider>
      <div>
        <Conditions />
      </div>
      <div
        className="protocols"
        style={{
          backgroundColor: "white",
          padding: "20px",
        }}
      >
        <h3 style={{ textAlign: "center", paddingLeft: 0 }}>
          ER, care protocols, and other resources
        </h3>

        <p>
          For more information about Emergency Room precautions and protocols,
          <Link
            to="/resources/er"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            {" "}
            click here.
          </Link>
        </p>
        <p>
          For more information about Care Protocols, click here for{" "}
          <Link
            to="/resources/op"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            Outpatient Protocols
          </Link>{" "}
          and{" "}
          <Link
            to="/resources/icu"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            Intensive Care Protocols.
          </Link>{" "}
        </p>
        <p style={{ paddingBottom: "10px" }}>
          For more information about Air Stacking or Glossopharyngeal Breathing
          (GPB),{" "}
          <Link
            to="/resources/as"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            click here.
          </Link>{" "}
        </p>
        <p style={{ paddingBottom: "20px" }}>
          For more information about SMA Types 1 and 2 and Congenital Myopathies
          in Infants and Small Children,{" "}
          <Link
            to="/resources/sma"
            style={{ textDecoration: "none", color: "darkblue" }}
          >
            click here.
          </Link>{" "}
        </p>
        <Material />
        <Support />
      </div>
    </div>
  );
};

export default Resources;
